import { useQuery } from '@tanstack/react-query';

import { RQ_SEARCH_CATEGORY_FILTERS } from '../ReactQuery/cacheKeys';

import { fetchCategoryFilters } from './api';

import { Language, Locale } from '@/modules/language/constants';
import { SupportedLocation } from '@/modules/location/constants';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';

export function useCategoryFilters() {
  const { location } = useCurrentLocation();

  const lang = location === SupportedLocation.GB ? Language.en : Locale.ENUS;

  return useQuery({
    queryKey: [RQ_SEARCH_CATEGORY_FILTERS, lang],
    queryFn: () => fetchCategoryFilters({ lang }),
  });
}
